import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { FaChevronLeft } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import SubmitBtn from '../../../../Components/Buttons/SubmitBtn';
import { FormGroup } from '../../../../Components/FormGroup/FormGroup';
import { clearPromoteUser } from '../../../../Redux/slices/user';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import {
  convertToNumber,
  debounce,
  ErrorMessageHandler,
  isNumeric,
  onlyNotSpecialCharacters
} from '../../../../_helpers/_methods';

function GeneralInfoForm({ url, userType }) {
  const lang = useSelector((state) => state?.local?.local);
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const { id, edit: isEdit } = useParams();
  const nagivate = useNavigate();
  const dispatch = useDispatch();

  const [isEmailInValid, setIsEmailInValid] = useState(false);
  const [isPhoneInValid, setIsPhoneInValid] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    // setError,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {}
  });
  const [user, setUser] = useState(null);
  const [officeType, setOfficeType] = useState([]);
  const [province, setProvince] = useState([]);
  const [selectedOfficeType, setSelectedOfficeType] = useState(null);
  const [selectedProvince, setSelectedProvince] = useState(null);
  const local = useSelector((state) => state.local.local);
  const promotion = searchParams.get('promotion');
  const promotionUser = useSelector((state) => state.user.promotionUser);

  useEffect(() => {
    const getOfficeType = async () => {
      try {
        let response = await fetchWrapper.get('/office-type/');
        let data = response.data.results.map((office_type) => ({
          id: office_type.id,
          label: office_type.title,
          value: office_type.title
        }));
        setOfficeType(data);
      } catch (error) {
        ErrorMessageHandler(error);
      }
    };
    const getProvince = async () => {
      try {
        let response = await fetchWrapper.get('/province/');
        let data = response.results.map((province) => ({
          id: province.id,
          label: local === 'ne' ? province.title : province.title_en,
          value: province.title
        }));
        setProvince(data);
      } catch (error) {
        ErrorMessageHandler(error);
      }
    };
    getProvince();
    getOfficeType();
  }, []);

  useEffect(() => {
    if (id) {
      const getUserInfo = async () => {
        try {
          let response = await fetchWrapper.get(`${url}${id}/`);
          setUser(response.data);
        } catch (error) {
          ErrorMessageHandler(error);
        }
      };
      getUserInfo();
    }
  }, [id]);

  useEffect(() => {
    return () => {
      dispatch(clearPromoteUser());
    };
  }, []);

  useEffect(() => {
    if (isEdit && user && officeType.length > 0 && province.length > 0) {
      setValue('fullname', user.fullname);
      setValue('phone', user?.phone);
      setValue('email', user.email);

      setValue('office_name', user.office_name);
      setValue('office_address', user.office_address);
      setValue('remarks', user.remarks);

      let ourOfficeType = officeType?.filter((item) => item?.value === user.office_type)[0];
      if (userType === 'super_admin') {
        setSelectedOfficeType(officeType);
        setValue('office_type', officeType[0]?.id);
      } else {
        setSelectedOfficeType(ourOfficeType);
        setValue('office_type', ourOfficeType?.id);
      }
      setSelectedOfficeType(userType === 'super_admin' ? officeType : ourOfficeType);
      if (userType === 'super_admin') {
        ('');
      } else {
        let ourProvince = province?.filter((item) => item.id === user.province?.id)[0];
        setSelectedProvince(ourProvince);
        setValue('province', ourProvince?.id);
      }
    } else if (promotion) {
      setValue('fullname', promotionUser?.fullname);
      setValue('phone', promotionUser?.phone);
      setValue('email', promotionUser?.email);
    }
  }, [user, officeType, province, promotionUser]);

  const onSubmit = async (data) => {
    let body = { ...data, password: 'password', username: data.email };
    if (body.phone !== user?.phone && body.phone !== promotionUser?.phone) {
      if (!(await validatePhone({ phone: body.phone }))) {
        return;
      }
    }
    if (body.email !== user?.email && body.email !== promotionUser?.email) {
      if (!(await validateEmail({ email: body.email }))) {
        return;
      }
    }

    if (userType === 'cd_admin') {
      body.role = [5];
    } else if (userType === 'executive') {
      body.role = [4];
    } else if (userType === 'super_admin') {
      body.role = [1];
      body.active_role = 'superuser';
    }
    try {
      setIsLoading(true);
      if (id) {
        await fetchWrapper.patch(`${url}${id}/`, body);
        toast.success(
          <div className="d-flex">
            <FormattedMessage id={userType} /> <FormattedMessage id="successfully_updated" />
          </div>
        );
      } else {
        if (promotion) {
          let promotionUrl = '/promote/';
          body.role = promotion;
          body.user = promotionUser?.user;
          await fetchWrapper.post(promotionUrl, body);
        } else {
          await fetchWrapper.post(url, body);
        }
        toast.success(
          <div className="d-flex">
            <FormattedMessage id={userType} /> <FormattedMessage id="successfully_created" />
          </div>
        );
      }
      nagivate(-1);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      ErrorMessageHandler(error);
    }
  };
  const handleChange = (e, idname) => {
    setValue(idname, e.id);
  };

  const handlePhoneCheck = async (e) => {
    let body = { phone: e.target.value };
    await validatePhone(body);
  };

  const validatePhone = async (body) => {
    try {
      if (isEdit) {
        if (user?.phone !== body.phone) {
          await fetchWrapper.post('/validate-phone/', body);
          clearErrors('phone');
          setIsPhoneInValid(false);
        }
        return true;
      } else {
        await fetchWrapper.post('/validate-phone/', body);
        clearErrors('phone');
        setIsPhoneInValid(false);
        return true;
      }
    } catch (error) {
      setIsPhoneInValid(
        error.error[0]
          ? error.error[0]
          : lang === 'ne'
          ? error.error.non_field_error_np
          : error.error.non_field_error
      );
      return false;
    }
  };
  // const validatePhone = async (body) => {
  //   try {
  //     await fetchWrapper.post('/validate-phone/', body);
  //     clearErrors('phone');
  //     setIsPhoneInValid(true);
  //     return true;
  //   } catch (error) {
  //     setIsPhoneInValid(
  //       lang === 'ne' ? error.error?.non_field_error_np : error.error?.non_field_error
  //     );
  //     return false;
  //   }
  // };

  const handleEmailCheck = async (e) => {
    let body = { email: e.target.value };
    await validateEmail(body);
  };

  const validateEmail = async (body) => {
    try {
      await fetchWrapper.post('/validate-email/', body);
      clearErrors('email');
      setIsEmailInValid(true);
      return true;
    } catch (error) {
      setIsEmailInValid(
        lang === 'ne' ? error.error?.non_field_error_np : error.error?.non_field_error
      );
      return false;
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h4>
          <FormattedMessage id="personal_details" />
        </h4>
        <div className="row px-3">
          <div className="col-md-3">
            <FormattedMessage id="fullname">
              {(placeholder) => (
                <FormGroup
                  type="text"
                  id="fullname"
                  onChange={(e) => {
                    e.target.value = onlyNotSpecialCharacters(e.target.value);
                  }}
                  placeholder={placeholder[0]}
                  label={<FormattedMessage id="fullname" />}
                  register={register}
                  errorId={`fullname`}
                  error={errors}
                  required={true}
                />
              )}
            </FormattedMessage>
          </div>
          <div className="col-md-3">
            <FormattedMessage id="phone">
              {(placeholder) => (
                <FormGroup
                  type="text"
                  register={register}
                  placeholder={placeholder[0]}
                  min={0}
                  max={10}
                  error={errors}
                  id="phone"
                  label={<FormattedMessage id="phone" />}
                  onChange={(e) => {
                    if (isNumeric(e.target.value)) {
                      if (e.target.value.length === 10) {
                        debounce(handlePhoneCheck, 1000)(e);
                      }
                    } else {
                      e.target.value = convertToNumber(e.target.value);
                      if (e.target.value.length === 10) debounce(handlePhoneCheck, 1000)(e);
                    }
                  }}
                  errorId={`mobile_number`}
                  required={true}
                />
              )}
            </FormattedMessage>
            {errors.phone ? (
              ''
            ) : isPhoneInValid ? (
              <small className="text-danger">{isPhoneInValid}</small>
            ) : null}
          </div>
          <div className="col-md-3">
            <FormattedMessage id="email">
              {(placeholder) => (
                <FormGroup
                  type="email"
                  placeholder={placeholder[0]}
                  id="email"
                  errorId={`email`}
                  onChange={debounce(handleEmailCheck, 1000)}
                  label={<FormattedMessage id="email" />}
                  register={register}
                  error={errors}
                  required={true}
                />
              )}
            </FormattedMessage>
            {isEmailInValid ? <small className="text-danger">{isEmailInValid}</small> : null}
          </div>
        </div>
        <h4 className="mt-3">
          <FormattedMessage id="office_detail" />
        </h4>

        <div className="row px-3 mb-3">
          <div className="col-md-3">
            {userType === 'super_admin' ? (
              <FormGroup
                key={selectedOfficeType}
                type="text"
                id="office_type"
                defaultValue={'PCU'}
                register={register}
                label={<FormattedMessage id="office_type" />}
                options={officeType}
                error={errors}
                errorId={`office_type`}
                readOnly={true}
              />
            ) : (
              <FormattedMessage id="select_office_type">
                {(placeholder) => (
                  <FormGroup
                    key={selectedOfficeType}
                    type="select"
                    id="office_type"
                    placeholder={placeholder[0]}
                    defaultValue={selectedOfficeType}
                    label={<FormattedMessage id="office_type" />}
                    register={register}
                    onChange={(e) => {
                      setSelectedOfficeType(e);
                      return handleChange(e, 'office_type');
                    }}
                    options={officeType}
                    error={errors}
                    errorId={`office_type`}
                    required={true}
                  />
                )}
              </FormattedMessage>
            )}
          </div>
          {userType === 'super_admin' ? null : (
            <>
              <div className="col-md-3">
                <FormattedMessage id="select_province">
                  {(placeholder) => (
                    <FormGroup
                      key={selectedProvince}
                      type="select"
                      id="province"
                      placeholder={placeholder[0]}
                      defaultValue={selectedProvince}
                      label={<FormattedMessage id="province" />}
                      register={register}
                      onChange={(e) => {
                        setSelectedProvince(e);
                        return handleChange(e, 'province');
                      }}
                      options={province}
                      error={errors}
                      errorId={`province`}
                      required={true}
                    />
                  )}
                </FormattedMessage>
              </div>

              <div className="col-md-3">
                <FormattedMessage id="office_name">
                  {(placeholder) => (
                    <FormGroup
                      type="text"
                      placeholder={placeholder[0]}
                      id="office_name"
                      label={<FormattedMessage id="office_name" />}
                      register={register}
                      error={errors}
                      required={true}
                      errorId={`office_name`}
                    />
                  )}
                </FormattedMessage>
              </div>
              <div className="col-md-3">
                <FormattedMessage id="office_address">
                  {(placeholder) => (
                    <FormGroup
                      type="text"
                      placeholder={placeholder[0]}
                      id="office_address"
                      label={<FormattedMessage id="office_address" />}
                      register={register}
                      error={errors}
                      errorId={`office_address`}
                      required={true}
                    />
                  )}
                </FormattedMessage>
              </div>
            </>
          )}
        </div>

        <div className="col-md-4 pb-3">
          <h4>
            <FormattedMessage id="remarks" />
          </h4>
          <div className="px-3">
            <FormattedMessage id="remarks">
              {(placeholder) => (
                <FormGroup
                  id="remarks"
                  placeholder={placeholder[0]}
                  register={register}
                  // label={<FormattedMessage id="remarks" />}
                  error={errors}
                  // required={true}
                  type="textarea"
                />
              )}
            </FormattedMessage>
          </div>
        </div>
        <hr />
        <div className="d-flex my-4 ">
          <Button
            variant="secondary"
            onClick={() => {
              nagivate(-1);
            }}>
            <FaChevronLeft />
            <FormattedMessage id="button.back" />
          </Button>
          <SubmitBtn isLoading={isLoading} />
        </div>
      </form>
    </div>
  );
}

export default GeneralInfoForm;
